import { useContext } from 'react';
import { TelemetryContext, } from '../components/TelemetryProvider';
export const useTelemetryContext = () => {
    const ctx = useContext(TelemetryContext);
    if (ctx === null) {
        throw new Error('useTelemetryContext() cannot be called outside of a TelemetryProvider');
    }
    return ctx;
};
